export default __webpack_public_path__ + "static/media/logonilsson.22f0fdad.png";